module.exports = __webpack_public_path__ + "img/png.3989da6c.png";